<nb-card>
	<nb-card-body>
		<form [formGroup]="form">
			<div>
				<div class="label-flex">
					<label class="label label-row float-left" for="opportunity-id-input">ADD SALESFORCE OPPORTUNITY ID</label>
				</div>
				<input id="opportunity-id-input" name="opportunity-id" type="text" nbInput placeholder="Opportunity Id" formControlName="opportunityId" fullWidth autocomplete="user-password"
					   [readOnly]="readOnly">
				@if (isInvalid('opportunityId')) {
					<div class="validation-message">{{ getValidationErrors('opportunityId') | async }}</div>
				}
			</div>

			<div class="send-opportunity-id-btn">
				<div class="button-section">
					<button id="send-button" nbButton size="small" status="primary" (click)="send()" [disabled]="readOnly">SAVE</button>
				</div>
			</div>
		</form>

		<div class="data-compare-div">
			<nb-checkbox [disabled]="readOnly" [checked]="dataCompared" (checkedChange)="onDataComparedChanged()" id="compare-data">
				I have compared the data in Salesforce and Umbrella and confirm it is the same.
			</nb-checkbox>
		</div>
	</nb-card-body>
</nb-card>
